/**
 * Esquema de espera escalonado para la descarga sincrona de Balance General.
 *
 * NO es un abort duro a los 30s -- ese diseno ya se probo en este mismo
 * codebase (cliente axios global, ver lib/api/client.ts) y causo abortos
 * prematuros + reintentos + rate limiting real. Aqui:
 *   - A los 30s: se OFRECE (sin cancelar nada) la opcion de cambiar a correo.
 *   - A los 90s: recien ahi se CORTA la espera y se fuerza unicamente correo.
 */

export const BALANCE_SHEET_NOTICE_MS = 30000;
export const BALANCE_SHEET_CUTOFF_MS = 90000;

export function shouldShowWaitNotice(elapsedMs: number): boolean {
  return elapsedMs >= BALANCE_SHEET_NOTICE_MS;
}

export function shouldForceCutoff(elapsedMs: number): boolean {
  return elapsedMs >= BALANCE_SHEET_CUTOFF_MS;
}

/**
 * Condicion de carrera: si el usuario ya opto por el flujo de correo (desde
 * el aviso de 30s, el corte de 90s, o el boton directo) y LUEGO la descarga
 * sincrona original responde tardiamente (bien o mal), esa respuesta tardia
 * debe ignorarse -- nunca mostrar dos resultados contradictorios en pantalla.
 */
export function shouldIgnoreLateSyncResponse(emailFlowAlreadyChosen: boolean): boolean {
  return emailFlowAlreadyChosen;
}

export type ReportResponseOutcome = 'success' | 'json-error' | 'invalid';

export interface ReportResponseInfo {
  status: number;
  contentType: string | null;
  /** true si el response trae un nombre de archivo utilizable (Content-Disposition) */
  hasFileName: boolean;
}

/**
 * Replica la logica del legado (_Reports.cshtml sendRequest/xhr.onload):
 * - Content-Type application/json -> el backend devolvio un error estructurado.
 * - status 200 + nombre de archivo -> descarga binaria valida.
 * - cualquier otro caso -> respuesta invalida/corrupta.
 */
export function classifyReportResponse(info: ReportResponseInfo): ReportResponseOutcome {
  if (info.contentType?.includes('application/json')) {
    return 'json-error';
  }
  if (info.status === 200 && info.hasFileName) {
    return 'success';
  }
  return 'invalid';
}
